module.exports = __webpack_public_path__ + "img/button-spin-en.320713f0.png";